import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/spin.svg'


const _hoisted_1 = {
  key: 0,
  id: "loading"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "imagem de carregamento para aguardar"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

import { useStore } from '@/store';
  import { computed } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingSpinner',
  setup(__props) {

  const store = useStore();
  const isLoading = computed(() => store.state.isLoading);

return (_ctx: any,_cache: any) => {
  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : _createCommentVNode("", true)
}
}

})